import { Component, computed, input } from "@angular/core";

@Component({
  selector: "oct-spinner",
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="sizePx()"
      [attr.height]="sizePx()"
      viewBox="0 0 24 24"
      fill="none">
      <path
        class="spinner-track"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 2C10.6868 2 9.38642 2.25866 8.17317 2.7612C6.95991 3.26375 5.85752 4.00035 4.92893 4.92893C4.00035 5.85752 3.26375 6.95991 2.7612 8.17316C2.25866 9.38642 2 10.6868 2 12C2 13.3132 2.25866 14.6136 2.7612 15.8268C3.26375 17.0401 4.00035 18.1425 4.92893 19.0711C5.85752 19.9997 6.95991 20.7362 8.17316 21.2388C9.38642 21.7413 10.6868 22 12 22C13.3132 22 14.6136 21.7413 15.8268 21.2388C17.0401 20.7362 18.1425 19.9997 19.0711 19.0711C19.9997 18.1425 20.7362 17.0401 21.2388 15.8268C21.7413 14.6136 22 13.3132 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.76121C14.6136 2.25866 13.3132 2 12 2ZM7.4078 0.913445C8.86371 0.310389 10.4241 0 12 0C13.5759 0 15.1363 0.31039 16.5922 0.913446C18.0481 1.5165 19.371 2.40042 20.4853 3.51472C21.5996 4.62902 22.4835 5.95189 23.0866 7.4078C23.6896 8.86371 24 10.4241 24 12C24 13.5759 23.6896 15.1363 23.0866 16.5922C22.4835 18.0481 21.5996 19.371 20.4853 20.4853C19.371 21.5996 18.0481 22.4835 16.5922 23.0866C15.1363 23.6896 13.5759 24 12 24C10.4241 24 8.8637 23.6896 7.4078 23.0866C5.95189 22.4835 4.62902 21.5996 3.51472 20.4853C2.40041 19.371 1.5165 18.0481 0.913445 16.5922C0.310389 15.1363 0 13.5759 0 12C0 10.4241 0.310389 8.8637 0.913446 7.4078C1.5165 5.95189 2.40042 4.62902 3.51472 3.51472C4.62902 2.40041 5.95189 1.5165 7.4078 0.913445Z" />
      <g class="spinner-inner">
        <path
          d="M23 12C23 13.7359 22.5892 15.4472 21.8011 16.9939C21.013 18.5406 19.87 19.8788 18.4656 20.8992C17.0613 21.9195 15.4353 22.593 13.7208 22.8646C12.0062 23.1361 10.2518 22.998 8.60081 22.4616"
          stroke-width="2"
          stroke-linecap="round" />
      </g>
    </svg>
  `,
  styles: [
    `
      .spinner-track {
        fill: var(--oct-surface-disabled);
      }

      .spinner-inner {
        animation: rotate 1s linear infinite;
        transform-origin: 50% 50%;
        stroke: var(--oct-text-label);
      }

      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `,
  ],
})
export class OctSpinnerComponent {
  size = input<"sm" | "m" | "l" | "xl">("sm");
  sizePx = computed(() => this.sizeMap[this.size()] || this.sizeMap["m"]);

  private readonly sizeMap = {
    sm: 20,
    m: 20,
    l: 24,
    xl: 28,
  };
}
